module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門2_5_4.6c601402.png";